import { render, staticRenderFns } from "./RegraCampoEditor.vue?vue&type=template&id=5cb2e1fc&scoped=true"
import script from "./RegraCampoEditor.vue?vue&type=script&lang=js"
export * from "./RegraCampoEditor.vue?vue&type=script&lang=js"
import style0 from "./RegraCampoEditor.vue?vue&type=style&index=0&id=5cb2e1fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb2e1fc",
  null
  
)

export default component.exports